import { api } from '@/core/api/';

const baseApiURL = 'api/academicyears';

export const getCurrentAcademicYear = async () => {
  return await api.get(`${baseApiURL}/current`);
};

export const getPeiAcademicYears = async () => {
  return await api.get(`${baseApiURL}/peilist`);
};
